import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    StateStoring
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";


const MessageDetailList = (props) => {
    const dataGrid = useRef(null);
    const gridKey = "A06DEFAB-917F-46ED-A0CF-9D6472C9076F";
    const accessToken = props.oidc.user.access_token;

    const [dataSource, setDataSource] = useState(null);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");

    const saveState = useCallback((state) => {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout);
    }, [gridKey, currentLayout]);

    const loadState = useCallback(() => {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }, []);

    useEffect(() => {
        if (!props.headerId) return;

        const store = createStore({
            key: 'rowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/rf/Message/GetRFMessageDetails`,
            updateUrl: `${window._env_.REACT_APP_APIS}/rf/Message/UpdateRFMessageDetails`,
            deleteUrl: `${window._env_.REACT_APP_APIS}/rf/Message/DeleteRFMessageDetails`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    Key: props.headerId,
                };
            }
        });

        setDataSource(store);

        if (dataGrid.current?.instance) {
            dataGrid.current.instance().refresh();
        }

    }, [props.headerId]);

    const onContentReady = (e) => {
        if (!e.component._hasLoaded && dataSource) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    };

    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    };

    const onRowInserted = (e) => {
        e.data['RConsignee'] = props.headerId;
    };

    const deleteRecords = useCallback(() => {
        const deleteUrl = "rf/Message/DeleteRFMessageDetails";
        let result = confirm("<i>Are you sure you want to delete selected records?</i>", "Delete");

        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then(() => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch(() => {
                        dataGrid.current.instance().endCustomLoading();
                    });
            }
        });
    }, [selectedItemKeys]);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                ref={dataGrid}
                dataSource={dataSource}
                onContentReady={onContentReady}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onRowInserting={onRowInserted}
                height={props.panelHeight}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />

                <Column dataField="recordNumber" allowSorting={false} allowEditing={false} caption="Record#" />
                <Column dataField="creationDateTime" allowEditing={false} dataType="datetime" format="MM/dd/yyyy hh:mm aa" caption="Creation Auditable" allowSorting={false} />
                <Column dataField="fieldName" allowEditing={false} allowSorting={false} caption="Field Name" />
                <Column dataField="fieldType" allowEditing={false} allowSorting={false} caption="Field Type" />
                <Column dataField="value" allowSorting={false} caption="Value" />
                <Column dataField="lastUpdateDateTime" dataType="datetime" format="MM/dd/yyyy hh:mm aa" caption="Update Auditable" allowEditing={false} visible={false} allowSorting={false} />

                <Toolbar>

                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager
                            gridKey={gridKey}
                            dataGrid={dataGrid}
                            setCurrentLayout={setCurrentLayout}
                        />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}

export default connect(mapStateToProps)(MessageDetailList);
